package one.healthium.uscreen.ui.animation

import androidx.compose.animation.core.Easing
import androidx.compose.animation.core.LinearOutSlowInEasing
import one.healthium.uscreen.domain.models.AnimationType

const val BLOCK_APPEAR_DURATION = 350L

const val POST_TRANSITION_DELAY = BLOCK_APPEAR_DURATION

const val CTA_ANIM_DURATION = 350

const val STAGGER_ITEM_DELAY = 50L

const val STAGGER_ITEM_DURATION = 350

const val STAGGER_OFFSET_Y = 24f

const val PROGRESS_BAR_ANIM_DURATION = 350

/** Shared easing for all screen transition animations. */
val TRANSITION_EASING: Easing = LinearOutSlowInEasing

val DEFAULT_BLOCK_IN_ANIM = AnimationType.SlideOut
val DEFAULT_BLOCK_OUT_ANIM = AnimationType.SlideOut

val DEFAULT_CTA_IN_ANIM = AnimationType.None
val DEFAULT_CTA_OUT_ANIM = AnimationType.None

val DEFAULT_BG_IN_ANIM = AnimationType.SlideOut
val DEFAULT_BG_OUT_ANIM = AnimationType.SlideOut
